export let version = "v1.1.0";



// WEBPACK FOOTER //
// ./src/providers/version.ts